import React, { useEffect, useState } from "react";
import Card from "../../../components/Card";
import {
  Container,
  Row,
  Col,
  Nav,
  Tab,
  Button,
  Image,
  Modal,
  Form,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import img1 from "../../../assets/images/page-img/profile-bg2.jpg";
import axios from "axios";
import useAuth from "../../../utils/useAuth";
import { getToken } from "../../../utils/auth";

const ConnectionProfile = (userUid) => {
  useAuth();
  const navigate = useNavigate();
  const [connections, setConnections] = useState([]);

  const handleConnection = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/${userUid?.userUid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setConnections(response.data?.data?.connectionList);
    } catch (error) {
      console.log("Failed Fetching Requested to", error);
    }
  };

  useEffect(() => {
    handleConnection();
  }, []);


  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
  
            <Col lg="12">
                                  <div style={{ display:"flex", flexWrap:"wrap"}}>
            
                      {connections?.length === 0 ? (
                          <Col>
                          <Card className="card-block card-stretch card-height">
                            <Card.Body className="profile-page p-0">
                              <div className="profile-header-image">
                                <div 
                                  className="cover-container" 
                                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                >
                                  <img
                                    loading="lazy"
                                    src="/noconnection.png"
                                    alt="profile-bg"
                                    style={{ width: '300px', height: 'auto' }}
                                  />
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ) : (
                        connections?.map((data, index) => {
                          const userDetails =
                            data?.userId || data?.connectionUserId || {};
                          return (
                            <Col md={6} key={index}>
                            <Card className="card-block card-stretch card-height">
                              <Card.Body className="profile-page p-0">
                                <div className="profile-header-image">
                                  <div className="cover-container">
                                    <img
                                      loading="lazy"
                                      src={img1}
                                      alt="profile-bg"
                                      className="rounded img-fluid w-100"
                                    />
                                  </div>
                                  <div className="profile-info p-4">
                                    <div className="user-detail">
                                      <div className="d-flex flex-wrap justify-content-between align-items-start">
                                        <div className="profile-detail d-flex">
                                          <div className="profile-img pe-4">
                                            <img
                                              loading="lazy" style={{width:"100px", height:"100px"}}
                                              src={
                                                userDetails.profileImageLink || "/profile.png"
                                              }
                                              alt="profile-img"
                                              className="avatar-130 img-fluid"
                                            />
                                          </div>
                                          <div className="user-data-block">
                                            <h4>
                                              <div
                                                // onClick={() =>handleNavigateProfile(userDetails?.UID)}
                                              >
                                                {userDetails?.firstName} {userDetails?.lastName}
                                              </div>
                                              
                                            </h4>
                                            
                                          </div>
                                        </div>
                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                          );
                        })
                      )}
                    </div>
            </Col>
    </>
  );
};

export default ConnectionProfile;
